import React, { Component } from 'react';
import { Grid, Select, Divider, Card, Image, Button } from 'semantic-ui-react'
import { giftboxBlack, giftboxBlue} from '../../../config/constants.js'

class GiftPackaging extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBoxes: false,
            giftBox: false,
        }
    }

    showGiftBoxes = () => {
        console.log("gftx1 ++++++++++: showGiftBoxes");
        this.setState({
            showBoxes: true,
        })
    }

    setGiftBoxColor = () =>{
        this.setState({
            giftBox: true,
        })

        this.props.itemType !== 'jumper'
        ? this.props.updateOrderArray(this.props.arrayIndex, 'giftBoxColor', 'blue')
        : this.props.updateOrderArray(this.props.arrayIndex, 'giftBoxColor', 'black');
        
    }

    render() {

        const giftBoxPic = this.props.itemType !== 'jumper'
            ? <div><Divider horizontal>JUST 12,000 UGX </Divider>
            <Card >
                <Image center src={giftboxBlue} />
            </Card></div>
            : <div>
                <Divider horizontal>JUST 15,000 UGX </Divider>
            <Card >
                <Image center src={giftboxBlack} fluid/>
            </Card>
            </div>

         const giftBoxConfirmation  = this.state.giftBox
            ? <h4> GIFT BOX ADDED FOR  </h4>
            : ''

        const giftBoxColorDropdown = this.state.showBoxes
            ? <Select
                name="form-field-name"
                value={this.state.deliveryPerson}
                options={this.state.deliveryPersonChoices}
                onChange={this.handleDropDownChanges}
                searchable={false}
                clearable={false}
            />
            : ''

        return (
            <div>
                <Divider horizontal>BUYING A GIFT? </Divider>
                <Divider horizontal>ADD A GIFT WRAPPED BOX</Divider>
                {giftBoxPic}
                {/* <Divider horizontal>JUST {pricing} </Divider>
                <Card >
                    <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2FgiftBox%2FgiftBox_moonOfLifeSquare_600-min.jpg?alt=media&token=4251366a-ed2d-4e8a-9682-59f093724db1' fluid/>
                </Card> */}
                <Button color='blue' type="button" onClick={this.setGiftBoxColor}>CLICK HERE TO ADD GIFT BOX </Button>
                {giftBoxConfirmation}
               
            </div>
        );
    }
}

export default GiftPackaging;


// WEBPACK FOOTER //
// ./src/components/newSite/Packaging/GiftPackaging.js